"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Positions;

(function (Positions) {
  Positions["DEFAULT"] = "";
  Positions["TOP"] = "mdc-layout-grid__cell--align-top";
  Positions["BOTTOM"] = "mdc-layout-grid__cell--align-bottom";
  Positions["MIDDLE"] = "mdc-layout-grid__cell--align-middle";
})(Positions = exports.Positions || (exports.Positions = {}));